// El back envía las fechas del chat como "d/M/yyyy H:mm:ss" (UtilMundo.getJSONDate).

export function parsearFechaChat(texto) {
  if (!texto || typeof texto !== 'string') {
    return null;
  }
  const partes = texto.trim().split(' ');
  const [dia, mes, anio] = (partes[0] || '').split('/').map(Number);
  const [hora = 0, minuto = 0, segundo = 0] = (partes[1] || '').split(':').map(Number);
  if (!dia || !mes || !anio) {
    return null;
  }
  const fecha = new Date(anio, mes - 1, dia, hora, minuto, segundo);
  return isNaN(fecha.getTime()) ? null : fecha;
}

function dosDigitos(n) {
  return n < 10 ? '0' + n : String(n);
}

/** "2026-09-20 09:12", como en la maqueta aprobada. */
export function fechaHoraCorta(fecha) {
  if (!fecha) {
    return '';
  }
  return (
    fecha.getFullYear() + '-' + dosDigitos(fecha.getMonth() + 1) + '-' + dosDigitos(fecha.getDate()) +
    ' ' + dosDigitos(fecha.getHours()) + ':' + dosDigitos(fecha.getMinutes())
  );
}
